import type { AddressInput, ShippingAddress } from '../../../../modules/api';
import { EMPTY_ADDRESS_FORM, type AddressFormValues } from './addressValidation';

/** The create / update body for a filled form. Optional fields go out only
 *  when filled. */
export function toAddressParams(form: AddressFormValues): AddressInput {
  const line2 = form.line2.trim();
  const state = form.state.trim();
  const additional = form.additional.trim();
  return {
    name: form.name.trim(),
    phoneNumber: form.phone.trim(),
    firstLine: form.line1.trim(),
    city: form.city.trim(),
    zipcode: form.postalCode.trim(),
    country: form.country.trim(),
    ...(line2 ? { secondLine: line2 } : {}),
    ...(state ? { state } : {}),
    ...(additional ? { additional } : {}),
  };
}

/** A saved address back in form shape, for editing it. */
export function addressToForm(address: ShippingAddress): AddressFormValues {
  return {
    ...EMPTY_ADDRESS_FORM,
    name: address.name,
    phone: address.phoneNumber,
    addressSearch: address.firstLine,
    line1: address.firstLine,
    line2: address.secondLine ?? '',
    city: address.city,
    state: address.state ?? '',
    postalCode: address.zipcode,
    country: address.country,
    additional: address.additional ?? '',
  };
}
